
// List g�n�rique utilis�e pour remplir les listes d�roulantes
export class TechInfosModel  {
	public constructor() {
		this.userName = "";
		this.lang = "";
		this.flux = "";
		this.context = "";
		this.step = 0;
		this.idSite = "";
		this.idTransaction = "";
		this.barCode = "";
		this.JSONResult = "";

	}

	public userName: string;
	public lang: string;
	public flux: string;
	public context: string;
	public step: number;
	public idSite: string;
	public idTransaction: string;
	public barCode: string;
	public JSONResult: string;
}


